/* Session slide (simpleView) — text in English and German (same shape in both).
   The affirmation panel has fixed widths: keep the German short. */
import { ByLang, useL } from "i18n/lang";

const en = {
  // Eye-state buttons
  states: {
    open: "Awake",
    half: "Drowsy",
    closed: "Deep Sleep",
    dreaming: "Dreaming",
  },
  // Captions per eye state (currently not shown)
  captions: {
    open: "Waking Awareness",
    half: "Threshold of Sleep",
    closed: "The Deep Void",
    dreaming: "Conscious Within the Dream",
  },
  playAria: "Play",
  stopAria: "Stop",
  affirmations: "Affirmations",
  affirmSwitchAria: "Affirmations on or off",
  firstAfter: "First after",
  repeatEvery: "Repeat every",
  now: "now",
  noRepeat: "no repeat",
  played: "✓ played",
  minutes: (n: number) => `${n} min`,
  lessAria: (label: string) => `${label}: one minute less`,
  moreAria: (label: string) => `${label}: one minute more`,
  // Countdown
  off: "off",
  stopped: "stopped",
  untilFirst: "until first",
  untilNext: "until next",
  done: "done",
};

export type SimpleViewText = typeof en;

const de: SimpleViewText = {
  states: {
    open: "Wach",
    half: "Schläfrig",
    closed: "Tiefschlaf",
    dreaming: "Träumen",
  },
  captions: {
    open: "Wache Bewusstheit",
    half: "Schwelle des Schlafs",
    closed: "Die tiefe Leere",
    dreaming: "Bewusst im Traum",
  },
  playAria: "Abspielen",
  stopAria: "Stoppen",
  affirmations: "Affirmationen",
  affirmSwitchAria: "Affirmationen ein oder aus",
  firstAfter: "Erste nach",
  repeatEvery: "Wdh. alle", // "Wiederholen alle" wraps on phones
  now: "sofort",
  noRepeat: "keine Wdh.",
  played: "✓ gespielt",
  minutes: (n: number) => `${n} Min.`,
  lessAria: (label: string) => `${label}: eine Minute weniger`,
  moreAria: (label: string) => `${label}: eine Minute mehr`,
  off: "aus",
  stopped: "gestoppt",
  untilFirst: "bis zur ersten",
  untilNext: "bis zur nächsten",
  done: "fertig",
};

export const simpleViewText: ByLang<SimpleViewText> = { en, de };
export const useSimpleViewText = () => useL(simpleViewText);
